import { render, staticRenderFns } from "./seaBookingTrucking.vue?vue&type=template&id=c70bc49c&scoped=true&"
import script from "./seaBookingTrucking.vue?vue&type=script&lang=js&"
export * from "./seaBookingTrucking.vue?vue&type=script&lang=js&"
import style0 from "./seaBookingTrucking.vue?vue&type=style&index=0&id=c70bc49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70bc49c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c70bc49c')) {
      api.createRecord('c70bc49c', component.options)
    } else {
      api.reload('c70bc49c', component.options)
    }
    module.hot.accept("./seaBookingTrucking.vue?vue&type=template&id=c70bc49c&scoped=true&", function () {
      api.rerender('c70bc49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingTrucking.vue"
export default component.exports